import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import { z } from "zod";

export const buttonTo360ElementSchema = baseElementSchema.extend({
    type: z.literal("buttonTo360"),
});
export const buttonTo360ElementDataSchema = z.object({});
export type ButtonTo360Element = z.infer<typeof buttonTo360ElementSchema>;
export type ButtonTo360ElementData = z.infer<
    typeof buttonTo360ElementDataSchema
>;
